import { CreateBorrowIntent } from "@/features/treasury/treasury";

export default function TreasuryLendingBorrowPage() {
  return <CreateBorrowIntent />;
}
